"use client";

import Link from "next/link";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[#0b0b10] text-white">
      <div className="mx-auto w-full max-w-4xl px-6 py-16">
        <p className="text-[10px] uppercase tracking-[0.3em] text-white/60">
          Company
        </p>
        <h1 className="mt-3 text-3xl font-heading text-white">About Us</h1>
        <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white/70">
          <p className="font-medium text-white/80">Innovation Hopp Experiences Private Limited</p>
          <p className="mt-1">Building the future of event experiences</p>
        </div>

        <div className="mt-10 space-y-4 text-sm leading-relaxed text-white/70">
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">Who We Are</h2>
            <p className="mt-3">
              Hopp is a modern event discovery and ticketing platform designed to connect event organizers
              with attendees seamlessly. We believe in creating memorable experiences by making event
              management simple, secure, and enjoyable.
            </p>
            <p className="mt-3">
              &apos;Hopp&apos; is a platform for Customers to avail services with respect to going-out, dining, table
              reservations, movies, sports, events, ticketing, gift cards, payment facilitation at merchant
              premises, and other related services.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">Our Mission</h2>
            <p className="mt-3">
              Our mission is to empower event creators and bring communities together through seamless
              event experiences. We provide the tools and technology needed to host, manage, and attend
              events of all sizes.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">What We Offer</h2>
            <ul className="mt-3 list-disc space-y-2 pl-5 marker:text-white/50">
              <li>Easy event creation and management for hosts</li>
              <li>Secure online ticketing and payment processing</li>
              <li>QR code-based check-in system</li>
              <li>Real-time event analytics and insights</li>
              <li>Guest list management</li>
              <li>Table reservations at restaurants</li>
              <li>Movie ticket booking</li>
              <li>Sports facility and activity bookings</li>
              <li>Promotional tools including promo codes and vouchers</li>
              <li>Gift cards and loyalty programs</li>
            </ul>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">Our Commitment</h2>
            <p className="mt-3">
              We are committed to providing a safe, reliable, and user-friendly platform. Your security
              and privacy are our top priorities. We use industry-standard encryption and security
              measures to protect your data and transactions.
            </p>
            <p className="mt-3">
              To protect against the loss, misuse and alteration of information, we have appropriate
              physical, electronic and managerial procedures in place.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">Company Information</h2>
            <div className="mt-3 space-y-2">
              <p><span className="text-white/50">Legal Entity:</span> <span className="text-white">Innovation Hopp Experiences Private Limited</span></p>
              <p><span className="text-white/50">CIN:</span> <span className="text-white">U62099RJ2026PTC110279</span></p>
              <p><span className="text-white/50">Registered Address:</span> <span className="text-white">1101, Tower Crest Wing-1, Chandra Kala Colony, Durgapura, Jaipur, Rajasthan - 302018, India</span></p>
              <p><span className="text-white/50">Platform:</span> <span className="text-white">hopp.co.in</span></p>
              <p><span className="text-white/50">Email:</span>{" "}
                <a className="text-[var(--hopp-gold)] hover:underline" href="mailto:info@hopp.life">
                  info@hopp.life
                </a>
              </p>
            </div>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">Contact Us</h2>
            <p className="mt-3">
              We&apos;re here to help! If you have any questions, concerns, or feedback, please don&apos;t
              hesitate to reach out.
            </p>
            <div className="mt-4 grid gap-3 sm:grid-cols-2">
              <div className="rounded-xl bg-white/5 p-4">
                <p className="text-xs uppercase tracking-wider text-white/60">Customer Support</p>
                <a className="mt-1 block text-[var(--hopp-gold)] hover:underline" href="mailto:info@hopp.life">
                  info@hopp.life
                </a>
              </div>
              <div className="rounded-xl bg-white/5 p-4">
                <p className="text-xs uppercase tracking-wider text-white/60">For Event Hosts</p>
                <a className="mt-1 block text-[var(--hopp-gold)] hover:underline" href="mailto:info@hopp.life">
                  info@hopp.life
                </a>
              </div>
              <div className="rounded-xl bg-white/5 p-4">
                <p className="text-xs uppercase tracking-wider text-white/60">Business Inquiries</p>
                <a className="mt-1 block text-[var(--hopp-gold)] hover:underline" href="mailto:info@hopp.life">
                  info@hopp.life
                </a>
              </div>
              <div className="rounded-xl bg-white/5 p-4">
                <p className="text-xs uppercase tracking-wider text-white/60">Technical Support</p>
                <a className="mt-1 block text-[var(--hopp-gold)] hover:underline" href="mailto:info@hopp.life">
                  info@hopp.life
                </a>
              </div>
            </div>
          </section>

          <section className="rounded-2xl border border-[var(--hopp-gold)]/30 bg-[var(--hopp-gold)]/5 p-6">
            <h2 className="text-base font-semibold text-white">Quick Links</h2>
            <div className="mt-3 flex flex-wrap gap-3">
              <Link href="/legal/terms" className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm hover:bg-white/10 transition-colors">
                Terms of Service
              </Link>
              <Link href="/legal/privacy" className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm hover:bg-white/10 transition-colors">
                Privacy Policy
              </Link>
              <Link href="/refund" className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm hover:bg-white/10 transition-colors">
                Refund Policy
              </Link>
              <Link href="/contact" className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm hover:bg-white/10 transition-colors">
                Contact Us
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
